// Define the CellRenderer component
const CellRenderer = (value: string, columnId: string) => {
  if (columnId === '(1)-(2)') {
      const numericValue = Number(value);
      const backgroundColor = numericValue === 0 ? '#74C365' : '#e08792';
      return <div style={{ backgroundColor, padding: '8px' }}>{value}</div>;
  }
  return <div style={{ padding: '8px' }}>{value}</div>;
};
export default CellRenderer;